import { Facturation, Office } from "@/type/core/offices/offices.types";
import { SOMME_QCP_CERTIFICATE_CREATION_IN_CENTS } from "@utils/Constant";
import { BalanceTypes } from "@/type/core/qcp/qcp.types";
import { SelectedOfficesPayload } from "@/state/auth/AuthEvents";

export class OfficeHelper {
  static formatAlias = (aliasOfficeSelected: string): string => {
    if (!aliasOfficeSelected) {
      return "";
    } else {
      return aliasOfficeSelected && aliasOfficeSelected.startsWith("Cabinet")
        ? `${aliasOfficeSelected} - Jesignexpert`
        : `Cabinet ${aliasOfficeSelected} - Jesignexpert`;
    }
  };

  static officeHasEnoughBalance = (
    office?: Office,
    facturation?: Facturation,
  ): BalanceTypes => {
    if (office !== undefined) {
      if (office.belongsToGroup && !office.qcpCertificateEnabled) {
        return "groupDisabled";
      }
      if (office.withoutBalance) {
        return "withoutBalanceDisabled";
      }
      if (
        !office.belongsToGroup &&
        office.qcpCertificateEnabled &&
        office.officeMembershipStatus === "activated"
      ) {
        return "enoughBalance";
      }
    }

    if (facturation === undefined || facturation.officesBalance.length < 1) {
      return "notEnoughBalance";
    }

    for (const officeBalance of facturation.officesBalance) {
      if (
        officeBalance.officeId === office?.id &&
        ((officeBalance.availableCreditInCents &&
          officeBalance.availableCreditInCents >=
            SOMME_QCP_CERTIFICATE_CREATION_IN_CENTS) ||
          office?.belongsToGroup)
      ) {
        return "enoughBalance";
      }
    }

    return "notEnoughBalance";
  };

  static mapOfficeToSelectedOfficesPayload = (
    offices: Office[],
  ): SelectedOfficesPayload => {
    return offices.map((office) => ({
      id: office.id,
      rights: office.rights ?? [],
    }));
  };
}
